import { SquareSwitch } from "@/comps/toggle"
import { OfferingPrices } from "@/models/general"
import clsx from "clsx"
import { useTranslation } from "next-i18next"
import RenderBlock from "./render-block"

export interface Variant {
	pack_id: string
	monthly_tokens: number
	yearly_tokens: number
	monthly_price: number
	yearly_price: number
}

interface PricingOrCoinProps {
	isYearly: boolean
	setIsMonthly: (v: boolean) => void
	prices: OfferingPrices
	savePercent: number
	handlePurchaseClick: () => void
	setPackId: (id: string) => void
	packIndex: number
	setPackIndex: (index: number) => void
}

export default function PricingOrCoin(
	props: PricingOrCoinProps,
) {
	const {
		isYearly,
		setIsMonthly,
		prices,
		savePercent,
		handlePurchaseClick,
		setPackId,
		packIndex,
		setPackIndex,
	} = props
	const { t } = useTranslation()

	return (
		<div
			className={clsx(
				"flex w-full flex-col items-center",
				"pt-[44px] tablet:pt-[30px] desktop:pt-[42px] ",
			)}>
			<div className=" flex gap-[10px]">
				<span
					className={clsx(
						isYearly ? "text-blue-500" : "text-blue-900",
						"text-[18px] font-500 transition-colors",
					)}>
					{t("txt_monthly")}
				</span>
				<SquareSwitch
					onChange={setIsMonthly}
					enabled={isYearly}
				/>
				<span
					className={clsx(
						isYearly ? "text-blue-900" : "text-blue-500",
						"text-[18px] font-500 transition-colors ",
					)}>
					{t("txt_yearly")}
				</span>
				<span
					className={clsx(
						"text-[18px] font-500 transition-colors",
						isYearly ? "text-blue-900" : "text-blue-500",
					)}>
					{t("fs_save_percent", {
						percent: String(savePercent),
					})}
				</span>
			</div>

			<RenderBlock
				prices={prices}
				isYearly={isYearly}
				handlePurchaseClick={handlePurchaseClick}
				setPackId={setPackId}
				packIndex={packIndex}
				setPackIndex={setPackIndex}
			/>

			<p
				className={clsx(
					"pt-4 text-[16px] font-400 text-blue-500 transition-opacity",
					isYearly ? "opacity-100" : "opacity-0",
				)}>
				*{t("txt_billed_yearly")}
			</p>
		</div>
	)
}
